module.exports = "/images/video-background.svg?993b6888697a5f67ef5952eb3f2d1c98";